import React from "react";
import PropTypes from "prop-types";
import { Grid } from "react-bootstrap";
import classNames from "classnames";

const ActionGrid = ({ className, children }) => (
	<div className={classNames("page-header-action-grid", className)}>
		<Grid className="flex-center">{children}</Grid>
	</div>
);

ActionGrid.propTypes = {
	className: PropTypes.string,
	children: PropTypes.any.isRequired,
};

ActionGrid.defaultProps = {
	className: "",
};

export default ActionGrid;

export { default as Action } from "./action";
